import React, { useMemo, useState } from 'react';
import { Button, ColumnVisibilityMenu, DataTable, SearchInput, useDataTable } from '@onward-delivery/design';
import { profileColumns } from './columns';
import { filterProfiles } from './utils';

// Props only, no Context: the store module pulls @/hooks, which reaches App.js and firebase/auth,
// and jsdom can't load those.
const ProfilesTable = ({ rows = [], shipperOptions = [], loading = false, onCreate, onEdit }) => {
    const [search, setSearch] = useState('');

    const columns = useMemo(() => profileColumns({ onEdit, shipperOptions }), [onEdit, shipperOptions]);
    const visibleRows = useMemo(() => filterProfiles(rows, search), [rows, search]);

    // Edit is pinned so it stays reachable when the grid is wider than the page.
    const table = useDataTable({
        columns,
        data: visibleRows,
        getRowId: (row) => row.delivery_profile_id,
        columnPinning: { right: ['edit'] },
    });

    return (
        // The wrapper stays bare: `.onward-design .flex` only matches descendants.
        <div className="onward-design" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="flex min-h-0 flex-1 flex-col p-6">
                {/* Composed rather than DataTableToolbar, matching Forward Stocking: its search box can
                    only filter rows already in the table and leaves a spacer when disabled. */}
                <div className="mb-4 flex shrink-0 flex-wrap items-center gap-2 rounded-md border border-border bg-surface p-3">
                    <SearchInput
                        className="min-w-48 flex-1"
                        placeholder="Search delivery profiles…"
                        value={search}
                        onValueChange={setSearch}
                    />
                    <span className="shrink-0 text-sm text-muted">
                        {table.getFilteredRowModel().rows.length.toLocaleString()} profiles
                    </span>
                    <ColumnVisibilityMenu table={table} />
                    <Button className="ml-auto shrink-0" onClick={onCreate}>
                        Create delivery profile
                    </Button>
                </div>
                <DataTable
                    table={table}
                    isLoading={loading}
                    emptyState={search ? 'No profiles match your search' : 'No delivery profiles yet'}
                    className="mb-24 flex min-h-0 w-full min-w-0 flex-1 flex-col [&>div>table>thead]:sticky [&>div>table>thead]:top-0 [&>div>table>thead]:z-10"
                />
            </div>
        </div>
    );
};

export default ProfilesTable;
